// extracted by mini-css-extract-plugin
export default {"root":"style-module__root___RUtMs","root__right":"style-module__root__right___D8dwK","root__area":"style-module__root__area___MIr3l","root__content":"style-module__root__content___gvZza","root__content_title":"style-module__root__content_title___Duh6F","root__content_description":"style-module__root__content_description___kq0BQ","root__content_btn":"style-module__root__content_btn___pAHIl"};
    if(module.hot) {
      // 1697460464499
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  